<template>
    <v-card class="bg-polka" color="#385F73" theme="dark" max-width="644">
        <v-card-title class="subtitle font-medium"> Just For You </v-card-title>

        <v-card-subtitle>Your next maintainence is on us!</v-card-subtitle>

        <v-card-actions>
            <v-btn variant="text" to="request-maintenance">
                Request Maintenance
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<style lang="scss" scoped>
.bg-polka {
    background-image: radial-gradient(#d2d2d2 0.5px, #385f731e 0.5px);
    background-size: 10px 10px;
    border-radius: 15px;
}
</style>
